// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    RECEIVED_CATEGORY: null,
    RECEIVED_CATEGORIES: null,
    RECEIVED_CATEGORY_ORDER: null,

    CATEGORY_COLLAPSED: null,
    CATEGORY_EXPANDED: null,

    CATEGORY_DELETED: null,
});
